import { render, staticRenderFns } from "./AddGraphic.vue?vue&type=template&id=0ae45a51&"
import script from "./AddGraphic.vue?vue&type=script&lang=js&"
export * from "./AddGraphic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports